export default __webpack_public_path__ + "static/media/la_capelle17.95419fa3.jpg";